/**
 dynamic内部cell中的动态组件

 */

export default {
  name: 'dynamicCell',
  props: {
    //id前缀
    idPrefix: {
      type: String,
      default: 'idPrefix',
    },
    gridUtils: {
      type: Object,
      default: () => {
        return {}
      },
    },

    value: null,
  },
  data() {
    return {
      data: this.value,
    }
  },
  watch: {
    value(val) {
      this.data = val
    },
  },

  beforeDestroy() {
    this.data = null
  },

  methods: {},
  render(h) {
    let data = this.value
    let componentClassName = data.component?.code || data.component
    let property = data.property
    let propsCompile = data.parameter

    // 给每个子组件传一个 唯一标识进组件，方便子组件区分
    propsCompile.conCode = property

    let style = {
      position: 'absolute',
      zIndex: data.zIndex,
    }

    style = Object.assign(style, data.style)
    let telaSpace = this.gridUtils.telaSpace
    if (data.telaSpace || data.telaSpace === 0) {
      telaSpace = data.telaSpace
    }

    style.left = data.offsetX * this.gridUtils.wCol + telaSpace / 2 + 'px'
    style.top = data.offsetY * this.gridUtils.hRow + telaSpace / 2 + 'px'
    style.width = data.width * this.gridUtils.wCol - telaSpace + 'px'
    style.height = data.height * this.gridUtils.hRow - telaSpace + 'px'

    let vNodeFn = h(componentClassName, {
      props: propsCompile,
      style: style,
    })

    return vNodeFn
  },
}
